function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.592 4.09H19.41a.682.682 0 010-1.364h8.182a.682.682 0 010 1.364z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.865 6.817a.682.682 0 01-.483-1.163l2.246-2.246-2.245-2.244a.682.682 0 01.965-.965l2.727 2.728a.682.682 0 010 .964l-2.727 2.727a.685.685 0 01-.483.2zM9.864 4.09H1.682a.682.682 0 010-1.364h8.182a.682.682 0 010 1.364z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.41 6.817a.685.685 0 01-.483-.199L1.199 3.891a.682.682 0 010-.964L3.927.199a.682.682 0 01.964.965L2.646 3.408l2.245 2.245a.682.682 0 01-.481 1.164zM7.41 17.288a2.2 2.2 0 00-1.555.638.682.682 0 000 .964l9.71 9.712A4.747 4.747 0 0018.943 30h3.195a6.144 6.144 0 006.137-6.137v-7.5a1.365 1.365 0 00-2.727 0v.682a.682.682 0 01-1.364 0v-2.046a1.365 1.365 0 00-2.727 0v2.046a.682.682 0 01-1.364 0v-3.41a1.365 1.365 0 00-2.727 0v3.41a.682.682 0 01-1.364 0V6.817a1.365 1.365 0 00-2.727 0v12.955a.683.683 0 01-1.09.546l-3.46-2.595a2.191 2.191 0 00-1.314-.435z",
  fill: "currentColor"
})));